import { Component, Input, OnInit } from '@angular/core';
import { CommonService } from '@app/_services';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { ToastrService } from 'ngx-toastr';
import { environment } from '@environments/environment';
import { UserService } from '@app/user/user.service';

@Component({
  selector: 'app-screen-shot-modal',
  templateUrl: './screen-shot-modal.component.html',
  styleUrls: ['./screen-shot-modal.component.less']
})
export class ScreenShotModalComponent implements OnInit {

  @Input() webInstructions: any;
  @Input() index: number;
  @Input() endPointResults: any;

  lgScreenShot: any;
  screenShotModal: any = this.activeModal;
   randomStr :any= Math.random().toString(36).substring(7);

  constructor(private CommonServices: CommonService, private Toastr: ToastrService,
    private userService: UserService, public activeModal: NgbActiveModal, private toastr: ToastrService) { }

  ngOnInit() {
    this.initialiseScreenShot();
  }

  dataURItoBlob(dataURI) {
    var byteString;
            if (dataURI.split(',')[0].indexOf('base64') >= 0)
                byteString = atob(dataURI.split(',')[1]);
            else
                byteString = unescape(dataURI.split(',')[1]);
            // separate out the mime component
            var mimeString = dataURI.split(',')[0].split(':')[1].split(';')[0];
            // write the bytes of the string to a typed array
            var ia = new Uint8Array(byteString.length);
            for (var i = 0; i < byteString.length; i++) {
                ia[i] = byteString.charCodeAt(i);
            }
            return new Blob([ia], {type:mimeString});
 }
 

  exportImage(path) {
    const imageBlob = this.dataURItoBlob(path.path);
    const imageFile =new File([imageBlob], this.randomStr+'.jpg', {
      type: "'image/jpeg'"
    });
    let formData = new FormData();
    formData.append("file0", imageFile);
    this.userService.uploadFile(this.endPointResults.environment.projectSqlId, formData, false, false, false, false, this.randomStr+'.jpg').subscribe(data => {
          if (data.code == 200) {
        this.toastr.success("file uploaded successfully");
      } else {
        this.toastr.error(data.message);
      }
    });
  }
  donwloaURI(path): void {
    const link = document.createElement("a");
    link.href = path;
    link.download = this.randomStr+'.jpg';
    link.click();
  }

  initialiseScreenShot(): void {
    console.log('webInstructions', this.webInstructions);
    if (this.webInstructions) {
      const webInstruction = this.webInstructions[this.index];
      this.lgScreenShot = {
        index: this.index,
        length: this.webInstructions.length,
        name: webInstruction.name
      };

      if (webInstruction && webInstruction.browserScreenShot) {
        this.lgScreenShot.path = 'data:image/JPEG;base64,' + webInstruction.browserScreenShot;
      } else {
        this.loadScreenShot(webInstruction);
      }
    }
  }

  changeScreenshotimg(index): void {

    const webInstruction = this.webInstructions[index];
    this.lgScreenShot.index = index;
    this.lgScreenShot.name = webInstruction.name;

    if (webInstruction.executionStatus === 'PENDING') { return; }

    if (webInstruction && webInstruction.browserScreenShot) {
      this.lgScreenShot.path = 'data:image/JPEG;base64,' + webInstruction.browserScreenShot;
    } else {
      this.loadScreenShot(webInstruction);
    }
  }

  loadScreenShot(webInstruction: any): void {
    if(this.endPointResults) {
      this.CommonServices.loadScreenShot(webInstruction.noSqlId, this.endPointResults.execution.noSqlId).subscribe(data => {
        if (data) {
        this.lgScreenShot.path = 'data:image/JPEG;base64,' + data.response;
        webInstruction.browserScreenShot = data.response;
        }
      }, (err) => {
        this.Toastr.error('Failed to fetch image');
      });
    }
  }

}
